export const environment = {
    production: true,
    VERSION : "28720"
};